import React, { useEffect, useState } from 'react';

import Api, { exceptionNotificationAPI } from '../../services/api';
import FormCrud from '../../components/FormCrud';
import { options } from 'toastr';

const ReportYearForm = () => {
    const [cultureOptions, setCultureOptions] = useState([]);

    const loadData = async () => {
        Api.get('Culture/GetAllCultures').then((result) => {
            if (result && result.data) {
                const options = result.data.response.map(item => ({ value: item.cultureID, text: item.cultureDisplayName}));
                setCultureOptions(options)
            }
        }).catch((error) => {
            exceptionNotificationAPI(error);
        });
    }

    useEffect(() => {
            loadData();
        }, []);

    const activeOptions = [
        { value: true, text: "Yes" },
        { value: false, text: "No" }
    ];

    const fields = [
        {
            label: "Report Year",
            name: "year",
            type: "input"
        },
        {
            label: "Start Date",
            name: "beginDate",
            type: "date"
        },
        {
            label: "End Date",
            name: "endDate",
            type: "date"
        },
        {
            label: "ESG Companies",
            name: "reportYearCompany",
            type: "select",
            required: false,
            multiple: true
        },
        {
            label: "Crop",
            name: "cultureID",
            type: "select",
            options: cultureOptions,
        },
        {
            label: "Is Active",
            name: "isActive",
            type: "select",
            options: activeOptions
        },
    ];

    return (
        <FormCrud formName={"reportYear"} title={"Report Year"} fields={fields}/>
    );
}

export default ReportYearForm;
